// Gatsby requirements
import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

// Components
import RichText from "utils/RichTextRenderer"

// Styles
import * as CSS from './Footer.module.scss'

const Footer = ({ previewData, url }) =>  {

    const data = useStaticQuery(graphql`
      query {
        storyblokEntry(full_slug: { eq: "site-configuration/footer" }) {
            content
            id
            uuid
            internalId
        }
      }
    `)

    const content = previewData?.content || JSON.parse(data?.storyblokEntry?.content);

    return (
        <footer className={CSS.footer}>
            
            <div className={CSS.wrapper}>
              <div>
                <Link to="/" aria-label="Link to homepage">
                    <img loading="lazy" className={CSS.logo} src="/frida_logo.svg" height="54" width="93" alt="Frida logo"/>
                </Link>
                <RichText content={content?.firstColumn} />
              </div>
              <div><RichText content={content?.secondColumn} /></div>
              <div>
                <RichText content={content?.thirdColumn} />
                <img width="73" height="79" src="/legitscript-2025.png" alt="LegitScript certification for Frida" loading="lazy" />
              </div>
            </div>

            <div className={CSS.bottomText}>
              <div>
                <a href="https://www.instagram.com/talkwithfrida" aria-label="Link to Frida's instagram">
                  <img loading="lazy" style={{marginRight: '1em'}} src="/icons/instagram-icon.svg" alt="instagram icon" width="37" height="37" />
                </a>
                <a href="https://www.facebook.com/TalkWithFrida/" aria-label="Link to Frida's facebook">
                  <img loading="lazy" src="/icons/facebook-icon.svg" alt="facebook icon" width="37" height="37" />
                </a>
              </div>
              <div className={CSS.bottomLinks}>
                <RichText content={content?.bottomRow} />
              </div>
            </div>

            {url === 'about' ? <p className={`${CSS.wrapper} ${CSS.vaihe}`}>Website development provided by <a href="https://vaihe.com" target="blank" rel="noreferrer noopener">Vaihe</a>.</p> : ''}

        </footer>
    )
}

export default Footer
